export function dialNumber(phone, scheme = "tel") {
  if (!phone) return;
  const digits = String(phone).replace(/[^\d+]/g, "");
  window.location.href = `${scheme}:${digits}`;
}
